import * as d3 from 'd3';
import { DefaultTheme } from 'styled-components';
import theme from 'src/theme/theme';

type Arguments = {
  graph: d3.Selection<null, unknown, null, undefined>;
  transform: string;
  axis: d3.Axis<number> | d3.Axis<string | number>;
  theme?: DefaultTheme;
};

export const appendAxis = ({ graph, transform, axis, theme: t }: Arguments) => {
  const isAtlas = t && !t.isVaultVariant;
  const color = isAtlas
    ? t.atlas.semantic.color.type.default
    : theme.newPalette.neutral.N800;
  const dividerColor = isAtlas
    ? t.atlas.semantic.color.ui.divider.default
    : theme.newPalette.neutral.N300;
  const text: {
    text: string;
    pos: number;
    el: d3.Selection<SVGSVGElement, unknown, null, undefined>;
  }[] = [];
  graph
    .append('g')
    .attr('transform', transform)
    .style('font-size', theme.newTypography.textStyleBodySmall.fontSize)
    .style('font-family', theme.newTypography.textStyleBodySmall.fontFamily)
    .style('color', color)
    .call(axis)
    .call((g) => g.select('.domain').attr('stroke', dividerColor))
    .call((g) =>
      g
        .selectAll('.tick')
        .insert('rect', ':first-child')
        .attr('class', 'x-axis-bubble'),
    )
    .call((g) => g.selectAll('.tick line').attr('stroke', dividerColor))
    .call((g) =>
      g
        .selectAll('.tick text')
        .attr('class', function (d, i) {
          text.push({
            text: d as string,
            pos: i,
            el: d3.select(this as SVGSVGElement),
          });
          return `tick-label tick-label-I${(d as string)?.replace?.('/', '')}`;
        })
        .style('fill', 'black')
        .style('opacity', 1),
    );

  graph
    .selectAll('.x-axis-bubble')
    .data(text)
    .attr('x', (d) => {
      const bbox = d.el.node()?.getBBox();
      if (bbox) {
        return bbox.x - 12;
      }
      return 0;
    })
    .attr('y', (d) => {
      const bbox = d.el.node()?.getBBox();
      if (bbox) {
        return bbox.y - 7.5;
      }
      return 0;
    })
    .attr('width', (d) => {
      const bbox = d.el.node()?.getBBox();
      if (bbox) {
        return bbox.width + 24;
      }

      return 0;
    })
    .attr(
      'class',
      (d) => `tick-label-box tick-label-box-I${d.text?.replace?.('/', '')}`,
    )
    .style('opacity', 0)
    .attr('height', '30')
    .style('stroke', '#17353D')
    .style('fill', '#17353D')
    .attr('ry', 15)
    .attr('rx', 15);
};
